export enum UserNature {
    UserName,
    Email,
    PhoneNumber
}

export enum UserType {
    Student,
    Parent,
    Teacher,
    Sale,
    BusinessUser,
    Maintainer,
    CrmIntegrator,
    Developer = 100,
    Soroush = 101
}

export enum NewFLowStep {
    Introduction,
    Registration,
    ChooseMeeting,
    ChoosePlan,
    Dashboard
}

export enum Gender {
    Male,
    Female,
    Custom,
    MaleFemale
}

export enum RoadMapCardType {
    Meeting,
    Subscription,
    Trial
}

export enum SignupType {
    Normal,
    Trial
}


export enum PlanType {
    Premium,
    Economy,
    Trial,
}

export enum MeetingStatus {
    Scheduled,
    Holding,
    Held,
    NotHeld,
    Rescheduling,
    Rescheduled
}

export enum MeetingInviteeStatus {
    Invited,
    RescheduledByInvitee,
    RescheduledByCrm
}

export enum PspType {
    Sadad,
    Payping,
    SnappPay,
    OfflinePayment,
    DirectDebit,
    PaymentLink,
    Sep,
    Top,
    Fake,
    Free,
}
